import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config/api";

export default function Mocktest() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/book_categories.php`
        );

        if (!res.ok) {
          throw new Error("API request failed");
        }

        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Response is not JSON");
        }

        const data = await res.json();

        if (data?.success && Array.isArray(data.categories)) {
          const formatted = data.categories.map((cat) => ({
            id: cat.category_id,
            title: cat.category_name || "Untitled Category",
            image:
              cat.picture_url && cat.picture_url.trim() !== ""
                ? cat.picture_url
                : `${process.env.PUBLIC_URL}/assets/img/subject-placeholder.jpg`,

            // ✅ FIXED QUESTION COUNT (handles all cases)
            questions: Number(
              cat.total_questions ??
                cat.question_count ??
                cat.questions ??
                cat.total ??
                0
            ),
          }));

          setCategories(formatted);
        } else {
          setCategories([]);
          setError("No categories found");
        }
      } catch (err) {
        console.error("Category fetch error:", err);
        setError("Failed to load categories");
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className="pt-5 pb-5 bg-light">
      <div className="container">
        {/* HEADER */}
        <div className="row justify-content-center mb-4">
          <div className="col-lg-8 text-center">
            <h2 className="fw-bold mb-2 mt-4">Choose Your Test Category</h2>
            <p className="text-muted mb-0">
              Select a subject and start your practice
            </p>
          </div>
        </div>

        {/* LOADING */}
        {loading && (
          <div className="text-center py-5 fw-semibold text-muted">
            Loading test categories...
          </div>
        )}

        {/* ERROR */}
        {!loading && error && (
          <div className="alert alert-warning text-center">{error}</div>
        )}

        {/* EMPTY STATE */}
        {!loading && !error && categories.length === 0 && (
          <div className="text-center py-5 text-muted">
            No test categories available
          </div>
        )}

        {/* CATEGORY CARDS */}
        <div className="row gx-3 gy-3">
          {categories.map((cat) => (
            <div key={cat.id} className="col-6 col-md-6 col-lg-4">
              <div className=" h-100 overflow-hidden">
                {/* IMAGE */}
              <img

                  src={`${process.env.PUBLIC_URL}${cat.image}`} 
                  alt={cat.title}
                  className="card-img-top"
                />

                <div className="card-body d-flex flex-column p-3 pt-0">
                  {/* TITLE 
                  <h5 className="fw-semibold text-dark mb-2 text-center">
                    {cat.title}
                  </h5>*/}

                  <hr className="my-2" />

                  {/* INFO */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-infinity text-success fs-5"></i>
                      <span className="fw-semibold fs-6">
                        Unlimited Attempts
                      </span>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-circle-question text-danger fs-5"></i>
                      <span className="fw-semibold fs-6">
                        {cat.questions}+ Questions
                      </span>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="">
                    <Link
                      to="/subscription"
                      className="btn btn-primary w-100 fw-semibold"
                    >
                      Start Test
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
